import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CityPageTemplate from '../components/CityPageTemplate';
import { cityData } from '../data/cityData';
import { useEffect } from 'react';

const CityPage = () => {
  const { cityId } = useParams<{ cityId: string }>();
  const navigate = useNavigate();
  const cityInfo = cityId ? cityData[cityId] : null;

  useEffect(() => {
    if (!cityInfo) {
      navigate('/404');
    }
  }, [cityInfo, navigate]);

  if (!cityInfo) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{`${cityInfo.city} Chauffeur Service | Luxury Car Service in ${cityInfo.city}, ${cityInfo.stateAbbr}`}</title>
        <meta name="description" content={`Premium chauffeur service in ${cityInfo.city}, ${cityInfo.stateAbbr}. Luxury car service, airport transfers, and corporate transportation. Book your ${cityInfo.city} chauffeur today.`} />
        <meta name="keywords" content={`${cityInfo.city} chauffeur, ${cityInfo.city} car service, ${cityInfo.state} chauffeur, luxury car service ${cityInfo.city}, airport transfer ${cityInfo.city}, corporate transportation ${cityInfo.city}, ${cityInfo.airportName} chauffeur, ${cityInfo.fboName} transportation`} />
        <link rel="canonical" href={`https://tilimousine.com/chauffeur-${cityId}`} />
      </Helmet>
      <CityPageTemplate
        city={cityInfo.city}
        state={cityInfo.state}
        stateAbbr={cityInfo.stateAbbr}
        nearbyCities={cityInfo.nearbyCities}
        airportName={cityInfo.airportName}
        fboName={cityInfo.fboName}
        longDistanceRoutes={cityInfo.longDistanceRoutes}
      />
    </>
  );
};

export default CityPage; 